// migrated 2026-04-27 to SDK route workspaceProject.notifications (update / markAllRead)
import { getSDK } from '../../../shared/functions/sdk.js'

export const markNotificationRead = async function (notifId) {
  if (!notifId) return
  const root = this?.state?.root
  if (!root) return
  // Optimistic update
  root.update({
    notifications: (root.notifications || []).map(n =>
      n.id === notifId ? { ...n, read: true } : n
    )
  })
  try {
    await getSDK().execute('workspaceProject.notifications', 'update', { id: notifId })
  } catch (e) {
    console.error('[markNotificationRead]', e?.message || e)
  }
}

export const markAllNotificationsRead = async function () {
  const root = this?.state?.root
  if (!root) return
  const me = root.currentUserEmail
  if (!me) return
  // Optimistic update
  root.update({
    notifications: (root.notifications || []).map(n => ({ ...n, read: true }))
  })
  try {
    await getSDK().execute('workspaceProject.notifications', 'markAllRead', {})
  } catch (e) {
    console.error('[markAllNotificationsRead]', e?.message || e)
  }
}
